/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { JSXElementConstructor } from 'react';
import { Button } from 'reactstrap';
import './styles.scss';

export interface BasicAlertParams {
  message?: string | JSXElementConstructor<any>;
  type: 'success' | 'danger' | 'warning' | 'info' | 'secondary'
  hide?: boolean,
  children: any,
  className?: string,
  handleClose?: () => void,
  variant?: VariantType,
}

export enum VariantType {
  Absolute = 'absolute',
  Sticky = 'sticky',
}

const VARIANT_MAP: { [key in VariantType]: React.CSSProperties } = {
  [VariantType.Absolute]: {
    position: 'absolute',
    top: 0,
  },
  [VariantType.Sticky]: {
    position: 'sticky',
    top: '53px', // offset by header height
    zIndex: 2, // reset z-index so banner only stacks above body content & select dropdowns
  },
};

export const BannerAlert = ({ children, hide, type = 'success', className = '', handleClose, variant = VariantType.Absolute }: BasicAlertParams) => {

  if (!children || hide) {
    return null;
  }

  return (
    <div className={`alert-${type} ${className} alert--page banner--alert background-ThemeAccentExtralight`} style={VARIANT_MAP[variant]}>
      <div className='alert--page__info flex-fill text-ThemeAccentDark d-flex justify-content-center align-items-center'>{children}</div>
      {handleClose ? (
        <div>
          <Button color='link' className='p-0' onClick={handleClose}>
            <i className='fa fa-times' />
          </Button>
        </div>
      ) : null}
    </div>
  );
}
